import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import { COLORS } from "../../constants";
/**
 * CalendarIcon Component
 *
 * This component renders a calendar icon using FontAwesomeIcon.
 * It is designed to be used in a web environment.
 *
 * @param {Object} props - The properties passed to the CalendarIcon component.
 * @param {number} props.size - The size of the icon.
 * @param {string} props.color - The color of the icon.
 *
 * @returns {JSX.Element} The rendered calendar icon.
 */
const CalendarIcon = ({ icon, size, color }) => {
  return <FontAwesomeIcon icon={icon} size={size} color={color} />;
};
export default React.memo(CalendarIcon);
